

(function () {
  'use strict';

  var initialised = new WeakSet();

  function initSection(section) {
    if (!section || initialised.has(section)) return;

    var el = section.querySelector('.featured-drop__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    initialised.add(section);

    var id = section.dataset.sectionId;
    var displayMode = section.dataset.displayMode || 'slider';

    var isGridMode = displayMode === 'grid';
    var mq = window.matchMedia('(max-width: 768px)');
    var instance = null;

    function sync() {
      var shouldRun = isGridMode ? mq.matches : true;

      if (shouldRun && !instance) {
        instance = buildSwiper();
      } else if (!shouldRun && instance) {
        instance.destroy(true, true);
        instance = null;
      }
    }

    function buildSwiper() {
      var sw = new Swiper(el, {
        slidesPerView: 1.4,
        spaceBetween: 8,

        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        navigation: {
          prevEl: '#fd-prev-' + id,
          nextEl: '#fd-next-' + id
        },

        breakpoints: {
          550: { slidesPerView: 2.8, spaceBetween: 20 },
          769: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, spaceBetween: 20 }
        }
      });

      /* Images inside slides usually finish loading after Swiper
         has already measured them */
      var imgs = el.querySelectorAll('img');
      var pending = imgs.length;

      if (pending) {
        imgs.forEach(function (img) {
          if (img.complete) {
            pending--;
            return;
          }
          img.addEventListener('load', done);
          img.addEventListener('error', done);
        });
      }

      function done() {
        pending--;
        if (pending <= 0 && sw && !sw.destroyed) {
          sw.update();
        }
      }

      window.addEventListener('load', function () {
        if (sw && !sw.destroyed) sw.update();
      });

      return sw;
    }

    sync();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', sync);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(sync);
    }
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-featured-drop]')
      .forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
